var inStockFlag = false;
var inStockMenuId = 'inStockMenuIdAutoOpen';
(function () {
  this.excludedCollections = [];
  this.filter_params = {
    allowed_filters: ["Instruments", "Formats", "Artists", "Difficulty Level", "Genre", "Specialty Books", "String Count", "Stock Status", "Accessory Type", "Merch Type", "Category"],
    product_loading_ele: "#filtz__product-loading-div",
    product_processing_ele: "#product-template",
    menu_loading_ele: "#filtz__filter-bar",
    pagination: {
      liquid_pagination_element: "div#filtz__pagination-element",
      filtz_pagination_element: "div#filtz__pagination-element",
      pagination_template: "#filtz__pagination-template",
    },
    exclude_price: true,
    products_per_page: 48,
    // products_per_page_element: "#filtz__product-per-page",
    toggle_class: "clicked",
    sort_element: "#filtz__sort-by",
    menu_order: ["instrument","Buying Options","artist"],
    submenu_order: {
      Length: [50, 23, 45, 22],
      accessories_type:['Pick_packs','Jam_tracks','Clothing','Ect'],
      instrument:['Guitar','Bass','Drums','Piano','Collections'],
      "Buying Options":['printed','digital','includes_jam_track']
    },
    ranges: {
      price: ["0-10", "10-25", "25-50", "50-@max_range"],
    },
    option_removals: ['price'],
    tag_removals: ['designtype','badge','royalties_artist','royalty_parent_product','royalty_split_to_artist','royalty_artist'],
    submenu_removals: {
      Dose: [3, 10],
      Length: [23, 50],
    },
    get_filters_from_tags: true,
    get_filters_from_options: true,
    // show_vendor_as: "Brand",
    // show_product_type_as: "Pr Type",
    disable_stock_status_collection:['bundles','books','prints','prints','accessories','anthologies','guitar'],
    custom_headers: {
      // category: {
      //   header_name: "Category",
      // },
      instrument: {
        header_name: "Instruments",
      },
      artist: {
        header_name: "Artists",
      },
      "Buying Options": {
        header_name: "Formats",
      },
      "difficulty_level": {
        header_name: "Difficulty Level",
      },
      "genre": {
        header_name: "Genre",
      },
      "string_count": {
        header_name: "String Count",
      },
      "accessories_type": {
        header_name: "Accessory Type",
      },
      "stock_status": {
        header_name: "Stock Status",
      },
      "book_type": {
        header_name: "Specialty Books",
      },
      "category": {
        header_name: "Category",
      },
      "royalties_parent_product": {
        header_name: "Royalties Parent Product",
      },
      "royalty_artist": {
        header_name: "Royalty Artist",
      },
      "merch_type": {
        header_name: "Merch Type",
      }
    },
    menu: {
      parent_starting_html:
        '<div class="filters-bar" data-group="@header_key"><div class="filter-group"><h3 @drop_down_style>@header_name</h3>',
      parent_ending_html: "</div></div>",
      submenu_starting_html: '<ul @drop_down_style>',
      submenu_ending_html: "</ul>@view_more",
      submenu_html:
        '<li class="filtzoption @hide_view_more" id="filer_by_@menu_name"><input type="checkbox"><label for="filer_by_@menu_name">@menu_name</label></li>',
    },
    custom_menu: {

    },
    show_count: '<span class="@count_class"></span>',
    clear_all_element: '#filtz__clear-all-button',
    active_filters: {
    container: '.sg',
    clear_all_ele: '',
    // filters_holder: '.selected-filters',
    // filter_element:'<li class="tag selected-filters current-filter filter-selected--close" data-id="12">@filter_value</li>',
    // close_btn_class: 'current-filter',
},

    // clear_all_element: "#filtz__clear-all-button",
    // active_filters: {
    //   container: ".sg",
    //   clear_all_ele: " ",
    //   filters_holder: ".selected-filter",
    //   filter_element: "<li> @filter_value <span class='filter-selected--close current-filter'></span></li>",
    //   close_btn_class: "current-filter",
    // },
  };

  window.afterFilter = function (data) {
    let count = data.length;
    console.log("Filtering has done..");
    console.log("Process plugins like yopto etc....");

    let topEl = document.getElementById('MainContent');
    if( document.getElementById('Collection') != undefined ){
      topEl = document.querySelector('.collection-header');
    }
    topEl.scrollIntoView({ behavior: 'smooth', block: 'end'});

    $(".filters-toolbar__product-count").text(count + " products");
    document.querySelectorAll('.product--variant-item').forEach(item => {
      item.addEventListener('click', event => {
        event.preventDefault();
        //Get image to show
        let imageVariant = item.dataset.image;

        console.log('imageVariant',imageVariant);

        //Set active variant thumb
        item.parentNode.querySelector(".active-variant--thumb").classList.remove("active-variant--thumb");
        item.classList.add("active-variant--thumb");

        //Set active image variant
        document.querySelector("#"+imageVariant).parentNode.parentNode.querySelector('.active-product--variant').classList.remove('active-product--variant');
        document.querySelector("#"+imageVariant).classList.add("active-product--variant");
      })
    });

    // link badge wrapper to current variant link
    document.querySelectorAll('.product-card__badges').forEach(item => {
      item.addEventListener('click', event => {
        let cardLink = item.nextElementSibling.querySelector('.active-product--variant').parentNode.getAttribute("href");
        window.location = cardLink;
      })
    });
    const queryString = window.location.search;
    const urlParams = queryString.replace('?','').split('&');
    if(urlParams.includes('formats=printed')){
        // console.log(`bryan: ` + queryString)
        let clearfix = document.getElementsByClassName("printed-clearfix");
        for(let item of clearfix){
          if( !item.parentNode.querySelector('.printed-clearfix.active-variant--thumb') )
            item.click();
        }
    }
    const isDigitalTabBooksCollection = window.location.pathname.indexOf('/collections/digital-tab-books') !== -1;
    if(urlParams.includes('formats=digital') || isDigitalTabBooksCollection){
        let clearfix = document.getElementsByClassName("digital-clearfix");
        for(let item of clearfix){
          if( !item.parentNode.querySelector('.digital-clearfix.active-variant--thumb') )
            item.click();
        }
    }
    if(urlParams.includes('formats=includes-jam-track')){
        let clearfix = document.getElementsByClassName("jam-track-clearfix");
        for(let item of clearfix){
          if(!item.previousElementSibling.classList.contains('jam-track-clearfix'))
            item.click();
        }
    }
  };

  window.afterFilterBarCreation = function () {
    console.log("Filter bar created");

    // if(takeUrl.includes('books')){
    //    console.log("in include books");
    //   $('li.Books').html('<li class="filtzoption Books filtz__invoke-ele filtz__ref-1" id="filer_by_Books"><input type="checkbox"><label for="filer_by_Books">Books</label></li>');
    // }

    $(document).on("click", ".view-more", function (e) {
      e.preventDefault();
      var thisClick = $(this);
      if (thisClick.text().trim() == "View More") {
        thisClick.text("View Less");
        thisClick.closest(".filter-group").find(".hide-view-more").addClass("show");
      } else {
        thisClick.text("View More");
        thisClick.closest(".filter-group").find(".hide-view-more").removeClass("show");
      }
    });

    $('.filter-group h3').click(function(e){
      if($(this).hasClass('filtz-open')){
        $(this).removeClass('filtz-open');
        $(this).next().removeClass('filtz-open').slideUp();
      }else{
        $(this).addClass('filtz-open');
        $(this).next().addClass('filtz-open').slideDown();
      }
    });

    $('.mobile-filters .mobile-filter-button').click(function(e){
      $('.collection-filters--wrapper').addClass('open');
    });
    $('.collection-filters--wrapper button.mobile-nav--close').click(function(e){
      $('.collection-filters--wrapper').removeClass('open');
    });




    // viewMore();
    // $(document).on("click", ".view-more", function (e) {
    //   e.preventDefault();
    //   var thisClick = $(this);
    //   if (thisClick.text() == "View More ") {
    //     thisClick.text("View Less ");
    //     thisClick.closest(".filtzgroup").find(".show-hide-group").removeClass("hide");
    //   } else {
    //     thisClick.text("View More ");
    //     thisClick.closest(".filtzgroup").find(".show-hide-group").addClass("hide");
    //   }
    // });
  };

  window.afterAppend = function (data) {
    console.log("Called when products are appended as tail");
  };
  this.viewMore = function () {

    $(".filtzgroup").each(function () {
      var thisGroup = $(this);
      if ($(this).find(".filtzoption").length > 5) {
        if ($(this).find(".view-more").length) {
        } else {
          thisGroup.append('<a href="" class="view-more">View More </a>');
        }
        var counterOption = 1;
        thisGroup.find(".filtzoption").each(function () {
          if (counterOption > 5) {
            $(this).addClass("show-hide-group");
            $(this).addClass("hide");
          }
          counterOption++;
        });
      }
    });
  };
  /**
   * Set custom attributes for products (if any)
   */
  window.setProductData = function (data) {
    let item = data;

    item.img_id = "ProductCardImage-" + sectionId + "-" + data.id;
    item.wrapper_id = "ProductCardImageWrapper-" + sectionId + "-" + data.id;

    return item;
  };

  /**
   * ===========================
   * Handlebars helper functions
   * ===========================
   */

  /**
   * Set global liquid variables into handlebars
   * using object globalLiquidVariables
   */
  // console.log(globalLiquidVariables);
  if (
    typeof globalLiquidVariables !== "undefined" &&
    typeof globalLiquidVariables != null &&
    globalLiquidVariables != ""
  ) {
    Handlebars.registerHelper('globals', function (key) {
      // console.log(key);
      return globalLiquidVariables[key];
    });
  }
  const reduceOp = function (args, reducer) {
    args = Array.from(args);
    args.pop(); // => options
    var first = args.shift();
    return args.reduce(reducer, first);
  };

  Handlebars.registerHelper('findInstraments', function (TG) {
    // console.log(TG);
    var tagContainInstrument ="";
    var tagLowerCase="";
    var firstLetter="";
    let instrumentTag="";
    TG.forEach(function(val) {
      if(val.includes("instrument:") || val.includes(":Lyrics"))
      {
        tagContainInstrument = val.split(':').pop();
        tagLowerCase = tagContainInstrument.toLowerCase();
        firstLetter =  tagContainInstrument.charAt(0);
        //  console.log(firstLetter);
        instrumentTag +='<span class="instrument-label '+tagLowerCase+'">'+firstLetter+'<span class="label-hover">'+tagContainInstrument+'</span></span>';
      }

    });
    // console.log(instrumentTag);
    return instrumentTag;
    // console.log("one array completed");
  });

  Handlebars.registerHelper('findInstrumentClass', function (TG) {
    let instrumentClass="";
    TG.forEach(function(val) {
      // console.log(val);
      if(val.includes("instrument:"))
      {
        tagContainInstrument = val.split(':').pop();
        tagLowerCase = tagContainInstrument.toLowerCase();
        //  console.log(firstLetter);
        instrumentClass += tagLowerCase + ' ';
      }

    });
    return instrumentClass;
  });

  Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
      return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper({
    eq: function () {
      return reduceOp(arguments, (a, b) => a === b);
    },
    ne: function () {
      return reduceOp(arguments, (a, b) => a !== b);
    },
    lt: function () {
      return reduceOp(arguments, (a, b) => a < b);
    },
    gt: function () {
      return reduceOp(arguments, (a, b) => a > b);
    },
    lte: function () {
      return reduceOp(arguments, (a, b) => a <= b);
    },
    gte: function () {
      return reduceOp(arguments, (a, b) => a >= b);
    },
    and: function () {
      return reduceOp(arguments, (a, b) => a && b);
    },
    or: function () {
      return reduceOp(arguments, (a, b) => a || b);
    },
  });

  Handlebars.registerHelper('stickerTags', function (tagStickers) {
		let badgeString = '';

		for (var m = 0; m < tagStickers.length; m++) {
			let tagVal = tagStickers[m].toLowerCase();
			if (tagVal.indexOf('featured') > -1) {
				badgeString +=
					'<span class="price__badge price__badge--featured"><span>FEATURED</span></span>';
				break;
			} else {
				badgeString +=
          '<span class="price__badge price__badge--sale" aria-hidden="true"><span>SALE</span></span>';
          badgeString +=
          '<span class="price__badge price__badge--sold-out" aria-hidden="true"><span>SOLD OUT</span></span>';
          badgeString +=
					'<span class="price__badge price__badge--new" aria-hidden="true"><span>NEW</span></span>';
				break;
			}
		}

		return badgeString;
	});
  // put on handle bar{{{ BadgesTags  TG }}}
  Handlebars.registerHelper('BadgesTags', function (badgeTag) {
    let badgeString = '';

    if (badgeTag == '\n30%-off-') {
    badgeString +=
    '<div class="price__badge price__badge--off">30% Off</div>';
    }
    else if(badgeTag =='\ncoming-soon-' || badgeTag =='\ncoming-soon-pre-sale-'){
      badgeString +=
    ' <div class="price__badge price__badge--soon">Coming Soon</div>';
    }
    else if(badgeTag =='\nlow-stock-'){
      badgeString +=
    '<div class="price__badge price__badge--low-stock">Low Stock</div>';
    }
    else if(badgeTag =='\nout_of_print-'){
      badgeString +=
    '<div class="price__badge price__badge--low-stock">Out of print</div>';
    }
    else if(badgeTag =='\nnew-'){
      badgeString +=
    '<div class="price__badge price__badge--new">New</div>';
    }
    else if(badgeTag =='\nsale-'){
      badgeString +=
    '<div class="price__badge price__badge--sale">Sale</div>';
    }
    {

    }
    return badgeString;
    });

    Handlebars.registerHelper('strContains', function(str, subStr, options) {
      return (str.toLowerCase().includes(subStr.toLowerCase())) ? options.fn(this) : options.inverse(this);
    });


})();

(function () {
  this.devMode = false;

  function performanceLogger() {
    this.devMode = false;
    this.addEntry = function (name) {
      let self = this;

      if (self.devMode) {
        let funcName =
          arguments.length > 1 && typeof arguments[1] !== "undefined"
            ? arguments[1]
            : name;
        let state =
          arguments.length > 2 && typeof arguments[2] !== "undefined"
            ? arguments[2]
            : "";
        if (state != "") {
          state = state == "start" ? " started at " : " ended at ";
        }
        performance.mark(name);

        console.log(
          "## " +
            funcName +
            state +
            " at : " +
            performance.getEntriesByName(name)[0].startTime
        );
      }
    };

    this.measure = function (p1, p2, pName) {
      let self = this;

      if (self.devMode) {
        performance.measure(pName, p1, p2);
        let performanceDetails = performance.getEntriesByName(pName)[0];
        console.log(
          "# (Time) " +
            pName +
            " took " +
            performanceDetails.duration +
            " milliseconds to complete"
        );
      }
    };

    this.logInfo = function (log) {
      let self = this;

      if (self.devMode) {
        console.log("#-- " + log);
      }
    };
  }

  window.PF = new performanceLogger();
  PF.logInfo("performanceLogger() [PF] initialized.");

  var domLoaded = false,
    jQueryLoaded = false,
    resultsLoaded = false;

  window.goAhead =
    resultCount <= 0 || __.indexOf(excludedCollections, resultHandle) !== -1
      ? false
      : true;
  this.productClass = "flt__product-holder";
  this.parentClass = "flt__parent-menu";
  this.childClass = "flt__child-menu";
  this.parentKeyAttribute = "flt__menu-key";
  this.parentNameAttribute = "flt__menu-name";
  this.childKeyAttribute = "flt__child-key";
  this.childNameAttribute = "flt__child-name";
  this.baseToggleClass = "flt__selected";
  this.filterClass = "filtz__invoke-ele";
  this.countClass = "filtz__count-ele";
  this.filterApplied = 0;
  this.currentDisplayedCount = 0;
  this.excludedUrlFilters = ["q", "byfp", "fbclib"];

  PF.addEntry("process-start", "Starting process.");

  // ============ Filter =========== //
  function filter() {
    this.filterData = function (data, params) {
      PF.addEntry("filter-start", "Filtering data starts at");

      let filtered = __.filter(data, function (val, key) {
        let retVal = false;

        let productFilters = val.filters;
        let filterKeys = __.keys(productFilters);
        let parameterKeys = __.keys(params);
        let availableParameters = __.uniq(
          __.intersection(parameterKeys, filterKeys)
        );

        if (availableParameters.length >= parameterKeys.length) {
          let valueStatus = true;
          __.forEach(params, function (val_, key_) {
            let commonVals = __.uniq(__.intersection(val_, productFilters[key_]));
            if (commonVals.length == 0) {
              valueStatus = false;
            }
          });
          retVal = valueStatus;
        }
        return retVal;
      });

      PF.addEntry("filter-end", "Filtered data ends at ");
      PF.measure("filter-start", "filter-end", "DataFiltering");

      return filtered;
    };

    this.sortData = function (sortParams, data) {
      let self = this;

      PF.addEntry("sort-start", "Sorting data starts at");

      let sortObj = data;
      let prop = "T";
      let mode = true;

      switch (sortParams) {
        case "manual":
          prop = "MNL";
          mode = "asc";
          break;

        case "best-selling":
          prop = "BST";
          mode = "asc";
          break;

        case "price-ascending":
          prop = "P";
          mode = "asc";
          break;

        case "price-descending":
          prop = "P";
          mode = "desc";
          break;

        case "title-ascending":
          prop = "T";
          mode = "asc";
          break;

        case "title-descending":
          prop = "T";
          mode = "desc";
          break;

        case "created-descending":
          prop = "CAT";
          mode = "desc";
          break;

        case "created-ascending":
          prop = "CAT";
          mode = "asc";
          break;

        default:
          prop = "ORD";
          mode = "asc";
          break;
      }

      PF.addEntry("sort-end", "Sorted data at");
      PF.measure("sort-start", "sort-end", "DataSorting");

      return __.orderBy(sortObj, [prop], [mode]);
    };
  }

  if (goAhead) {
    window.F = new filter();
  }
  PF.logInfo("filter() initialized [F].");

  //=======================================//
  //=======================================//
  //=======================================//

  function emptyMenu() {
    const menuObject = {};
    menuObject.hasSubMenus = false;
    menuObject.orderNumber = 99999;
    menuObject.headerName = "";
    menuObject.headerKey = "";
    menuObject.subMenus = {};
    return menuObject;
  }

  function emptySubMenu() {
    const subMenuObject = {};
    subMenuObject.counter = 0;
    subMenuObject.orderNumber = 99999;
    subMenuObject.subMenuName = "";
    subMenuObject.subMenuKey = "";
    return subMenuObject;
  }

  function loadAndSetData() {
    let self = this;
    PF.logInfo("loadAndSetData() initialized [PF].");

    self.filterHolder = {};
    self.filterOrder = [];

    self.allowedFilters =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.allowed_filters) &&
      !__.isEmpty(filter_params.allowed_filters)
        ? filter_params.allowed_filters
        : false;

    self.currentData = [];
    self.hasRanges =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.ranges) &&
      !__.isEmpty(filter_params.ranges)
        ? filter_params.ranges
        : false;
    self.menuOrder =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.menu_order) &&
      !__.isEmpty(filter_params.menu_order)
        ? filter_params.menu_order
        : false;
    self.subMenuOrder =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.submenu_order) &&
      !__.isEmpty(filter_params.submenu_order)
        ? filter_params.submenu_order
        : false;
    self.tagRemovals =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.tag_removals) &&
      !__.isEmpty(filter_params.tag_removals)
        ? filter_params.tag_removals
        : false;
    self.optionRemovals =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.option_removals) &&
      !__.isEmpty(filter_params.option_removals)
        ? filter_params.option_removals
        : false;
    self.subMenuRemovals =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.submenu_removals) &&
      !__.isEmpty(filter_params.submenu_removals)
        ? filter_params.submenu_removals
        : false;
    self.customHeaders =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.custom_headers) &&
      !__.isEmpty(filter_params.custom_headers)
        ? filter_params.custom_headers
        : false;
    self.takeVendor =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.show_vendor_as) &&
      !__.isEmpty(filter_params.show_vendor_as)
        ? filter_params.show_vendor_as
        : false;
    self.takeProductType =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.show_product_type_as) &&
      !__.isEmpty(filter_params.show_product_type_as)
        ? filter_params.show_product_type_as
        : false;
    self.takeTags =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.get_filters_from_tags) &&
      filter_params.get_filters_from_tags == true
        ? true
        : false;
    self.takeOptions =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.get_filters_from_options) &&
      filter_params.get_filters_from_options == true
        ? true
        : false;
    self.excludePrice =
      !__.isNil(filter_params) &&
      !__.isNil(filter_params.exclude_price) &&
      filter_params.exclude_price == true
        ? true
        : false;

    // if (templateName == "search") {
    //     if (!applyFILTzOnSearch) {
    //         removeFilterLoading();
    //         self.goAhead = false;
    //     }
    // } else if (templateName == "collection") {
    //     if (
    //         basicChecker(collectionsWithNoFilters) &&
    //         collectionsWithNoFilters.length > 0
    //     ) {
    //         if (collectionsWithNoFilters.indexOf(resultHandle) === -1) {
    //             removeFilterLoading();
    //             self.goAhead = false;
    //         }
    //     }
    // }

    // if (self.goAhead) {
    //     self.initiateProcess();
    // }
  }

  let P1 = loadAndSetData.prototype;

  if (goAhead) {
    window.LSD = new loadAndSetData();
  }

  P1.createFilterObject = function (key) {
    let self = this;

    // PF.addEntry("create-filterobj-start", "Creating filter object");

    let orderNum =
      arguments.length > 0 &&
      !__.isUndefined(arguments[1]) &&
      parseInt(arguments[1]) >= 0
        ? parseInt(arguments[1])
        : 99999;
    let menuObj = new emptyMenu();
    __.set(menuObj, "headerKey", key);
    __.set(menuObj, "headerName", key);
    let hasCustomHeaders =
      self.customHeaders && __.hasIn(self.customHeaders, key)
        ? self.customHeaders[key]
        : false;
    if (hasCustomHeaders && __.hasIn(hasCustomHeaders, "header_name")) {
      __.set(menuObj, "headerName", hasCustomHeaders.header_name);
    }
    if (orderNum >= 0) {
      __.set(menuObj, "orderNumber", orderNum);
    }

    let subMenus = {};
    let subMenuOrder = self.getSubmenuOrder(key);
    if (subMenuOrder) {
      __.forEach(subMenuOrder, function (val, k) {
        let pushStatus =
          self.subMenuRemovals &&
          __.hasIn(self.subMenuRemovals, key) &&
          __.indexOf(self.subMenuRemovals[key], val) !== -1
            ? false
            : true;
        if (pushStatus) {
          let subMenuObj = new emptySubMenu();
          let subMenuName =
            hasCustomHeaders &&
            __.hasIn(hasCustomHeaders, "sub_menus") &&
            __.hasIn(hasCustomHeaders.sub_menus, val)
              ? hasCustomHeaders.sub_menus[val]
              : val;
          let subMenuKey = val;
          subMenuObj.subMenuName = subMenuName;
          subMenuObj.subMenuKey = subMenuKey;
          subMenuObj.orderNumber = k;
          __.set(subMenus, subMenuKey, subMenuObj);
        }
      });
      __.set(menuObj, "subMenus", subMenus);
    }

    //   PF.addEntry("create-filterobj-end", "Created filter object");
    //   PF.measure(
    //     "create-filterobj-start",
    //     "create-filterobj-end",
    //     "FilterObjectCreation"
    //   );

    return menuObj;
  };

  P1.getSubmenuOrder = function (key) {
    let self = this;

    //   PF.addEntry("get-submenu-order-start", "Getting submenu order");

    let order =
      self.hasRanges && __.hasIn(self.hasRanges, key)
        ? self.hasRanges[key]
        : false;
    if (!order) {
      order =
        self.subMenuOrder && __.hasIn(self.subMenuOrder, key)
          ? self.subMenuOrder[key]
          : false;
    }

    //   PF.addEntry("get-submenu-order-end", "Got submenu order");
    //   PF.measure(
    //     "get-submenu-order-start",
    //     "get-submenu-order-end",
    //     "GetSubMenuOrder"
    //   );

    return order;
  };

  P1.setFilterHolder = function () {
    let self = this;

    if (self.menuOrder) {
      __.forEach(self.menuOrder, function (value, key) {
        let status = true;
        if (value == "price" && self.excludePrice == true) {
          status = false;
        }
        if (status) {
          let menuObj = self.createFilterObject(value, key);
          __.set(self.filterHolder, value, menuObj);
        }
      });
    }

    if (self.hasRanges) {
      __.forEach(self.hasRanges, function (value, key) {
        let status = true;
        if (key == "price" && self.excludePrice == true) {
          status = false;
        }
        if (status) {
          if (!__.hasIn(self.filterHolder, key)) {
            let menuObj = self.createFilterObject(key);
            __.set(self.filterHolder, key, menuObj);
          }
        }
      });
    }

    if (self.takeVendor) {
      let menuObj = self.createFilterObject(self.takeVendor);
      __.set(self.filterHolder, self.takeVendor, menuObj);
    }

    if (self.takeProductType) {
      let menuObj = self.createFilterObject(self.takeProductType);
      __.set(self.filterHolder, self.takeProductType, menuObj);
    }
  };

  P1.setFilter = function (key, val) {
    let self = this;

    //   PF.addEntry("set-filter-start", "Set Filter Start");

    let retVal = new Object();
    retVal.key = key;
    retVal.val = val;
    let status = true;

    if (self.hasRanges && __.hasIn(self.hasRanges, key)) {
      let num = parseFloat(val);
      let range = false;
      let currentRanges = self.hasRanges[key];
      __.map(currentRanges, function (n) {
        let splittedNum = __.split(n, "-", 2);
        let fromValue =
          splittedNum[0] == "@max_range" ? 999999999999 : splittedNum[0];
        let toValue =
          splittedNum[1] == "@max_range" ? 999999999999 : splittedNum[1];
        if (__.inRange(num, fromValue, toValue)) {
          retVal.key = key;
          retVal.val = n;
        }
      });
    } else {
      if (self.subMenuRemovals && __.hasIn(self.subMenuRemovals, key)) {
        if (__.indexOf(self.subMenuRemovals[key], val) === -1) {
          status = true;
        }
      }
    }

    if (status) {
      let value = retVal.val;
      if (!__.hasIn(self.filterHolder, key)) {
        let menuObj = self.createFilterObject(key);
        __.set(self.filterHolder, key, menuObj);
      }
      __.set(self.filterHolder[key], "hasSubMenus", true);

      let subMenus = __.get(self.filterHolder[key], "subMenus");
      if (!__.hasIn(self.filterHolder[key].subMenus, value)) {
        let subMenuObj = new emptySubMenu();
        let subMenuName =
          self.customHeaders &&
          __.hasIn(self.customHeaders, key) &&
          __.hasIn(self.customHeaders[key], "sub_menus") &&
          __.hasIn(self.customHeaders.sub_menus, value)
            ? self.customHeaders[key].sub_menus[value]
            : value;
        let subMenuKey = val;
        let orderNum =
          self.subMenuOrder &&
          __.hasIn(self.subMenuOrder, key) &&
          __.indexOf(self.subMenuOrder[key], value) !== -1
            ? __.indexOf(self.subMenuOrder[key], value)
            : 99999;

        if(key=='Buying Options' && __.hasIn(self.subMenuOrder, key)){
          if(value.toLowerCase().includes('printed')){
            orderNum = __.indexOf(self.subMenuOrder[key], 'printed')
          }
          if(value.toLowerCase().includes('digital')){
            orderNum = __.indexOf(self.subMenuOrder[key], 'digital')
          }
        }

        subMenuObj.subMenuName = subMenuName;
        subMenuObj.subMenuKey = subMenuKey;
        subMenuObj.orderNumber = orderNum;
        __.set(self.filterHolder[key].subMenus, subMenuKey, subMenuObj);
      }

      let subMenuCounter =
        __.parseInt(__.get(self.filterHolder[key].subMenus[value], "counter")) +
        1;
      __.set(self.filterHolder[key].subMenus[value], "counter", subMenuCounter);

      //   PF.addEntry("set-filter-end", "Set Filter Ended");
      //   PF.measure("set-filter-start", "set-filter-end", "SetFilter");

      return retVal;
    } else {
      //   PF.addEntry("set-filter-end", "Set Filter Ended");
      //   PF.measure("set-filter-start", "set-filter-end", "SetFilter");

      return false;
    }
  };

  P1.setProductFilters = function (prod) {
    let self = this;

    PF.addEntry(
      "set-product-filters-start",
      "Setting product filters of ID:" + prod.id
    );

    let filters = {};

    if (!self.excludePrice) {
      if (!__.hasIn(prod, "P")) {
        throw new Error(
          "Price is not in valid format. Please provide price as P"
        );
      }
      __.set(filters, "price", []);
      let filterObj = self.setFilter("price", __.divide(prod.P, 100));
      if (filterObj.val) {
        filters.price.push(filterObj.val);
      }
    }

    if (self.takeVendor) {
      if (!__.hasIn(prod, "V")) {
        throw new Error(
          "Vendor is not in valid format. Please provide vendor as V"
        );
      }
      __.set(filters, self.takeVendor, []);
      let vendor = __.get(prod, "V");
      let filterObj = self.setFilter(self.takeVendor, vendor);
      if (filterObj.val) {
        filters[self.takeVendor].push(filterObj.val);
      }
    }

    if (self.takeProductType) {
      if (!__.hasIn(prod, "PT")) {
        throw new Error(
          "Product type is not in valid format. Please provide product_type as PT"
        );
      }
      __.set(filters, self.takeProductType, []);
      let productType = __.get(prod, "PT");
      let filterObj = self.setFilter(self.takeProductType, productType);
      if (filterObj.val) {
        filters[self.takeProductType].push(filterObj.val);
      }
    }

    if (self.takeTags) {
      let tags = __.hasIn(prod, "TG") && __.isArray(prod.TG) ? prod.TG : false;
      // console.log(tags);
      __.forEach(tags, function (tag) {
        if (__.includes(tag, ":")) {
          let tagArray = __.split(tag, ":");
          if (!__.isNil(tagArray[0]) && !__.isNil(tagArray[1])) {
            if (
              self.tagRemovals &&
              __.indexOf(self.tagRemovals, tagArray[0]) == -1
            ) {
              let tagKey = tagArray[0];
              let tagValue = tagArray[1];
              let filterObj = self.setFilter(tagKey, tagValue);
              if (filterObj.val) {
                if (!__.hasIn(filters, tagKey)) {
                  __.set(filters, tagKey, []);
                }
                if (__.indexOf(filters[tagKey], filterObj.val) == -1) {
                  filters[tagKey].push(filterObj.val);
                }
              }
            }
          }
        }
      });
    }
    if (self.takeOptions) {
      let options = __.hasIn(prod, "O") && __.isArray(prod.O) ? prod.O : false;
      // console.log(options);
      if (options) {
        __.forEach(options, function (option) {
          if (option.name != "Title") {
            let optionKey = option.name;

            if (
              self.optionRemovals &&
              __.indexOf(self.optionRemovals, optionKey) == -1
            ) {
              if(optionKey.includes("Pattern") ||optionKey.includes("pattern")  ){
                optionKey = 'Pattern';
              }
              if(optionKey.includes("Colour") ||optionKey.includes("colour") || optionKey.includes("COLOUR")  ){
                optionKey = 'Colour';
              }
               if(optionKey.toLowerCase().includes("digital")){
                 optionKey = 'Digital';
               }
               if(optionKey.toLowerCase().includes("printed")){
                 optionKey = 'Printed';
               }
              __.forEach(option.values, function (opt) {
                if (opt != "Default Title") {
                  let filterObj = self.setFilter(optionKey, opt);
                  if(opt.toLowerCase().includes("digital")){
                    filterObj = self.setFilter(optionKey, 'Digital');
                  }
                  if(opt.toLowerCase().includes("printed")){
                    filterObj = self.setFilter(optionKey, 'Printed');
                  }
                  if (filterObj.val) {
                    if (!__.hasIn(filters, optionKey)) {
                      __.set(filters, optionKey, []);
                    }
                    if (__.indexOf(filters[optionKey], filterObj.val) == -1) {
                      filters[optionKey].push(filterObj.val);
                    }
                  }
                }
              });
            }
          }
        });
      }
    }

    __.set(prod, "filters", filters);
    // console.log(prod);
    PF.addEntry(
      "set-product-filters-end",
      "Set product filters of ID:" + prod.id
    );
    PF.measure(
      "set-product-filters-start",
      "set-product-filters-end",
      "SetProductFilters(" + prod.id + ")"
    );
  };

  P1.getUrlTag = function () {
    let currentUrl = window.location.href;
    if (__.includes(currentUrl, "?")) {
      currentUrl = currentUrl.substring(0, currentUrl.indexOf("?"));
    }
    let urlArray = __.split(currentUrl, "/collections/");
    // console.log(urlArray);
    let trimmedArray = __.split(urlArray[1], "/");
    return typeof trimmedArray[1] !== "undefined" &&
      typeof trimmedArray[1] !== null &&
      trimmedArray[1] != ""
      ? "/" + trimmedArray[1]
      : "";
  };

  P1.initiateProcess = function () {
    // console.log("inside initiate process");
    let self = this;

    if (
      basicChecker(resultCount) &&
      basicChecker(paginateProductsBy) &&
      basicChecker(resultHandle) &&
      basicChecker(shopUrl)
    ) {
      self.countOfData = resultCount;
      self.paginateBy = paginateProductsBy;
      self.handle = resultHandle;
      self.shopUrl = shopUrl;
      self.urlTag = self.getUrlTag();
      // console.log(self.urlTag);
      if (templateName == "collection") {
        self.collectionOrder = basicChecker(defaultOrder)
          ? defaultOrder
          : "title-ascending";
      } else if (templateName == "search") {
        self.collectionOrder = basicChecker(defaultOrder)
          ? defaultOrder
          : "product";
      }

      self.noOfPages = Math.ceil(self.countOfData / self.paginateBy);
      if (templateName == "collection") {
        self.urlString =
          self.shopUrl + "/collections/" + self.handle + self.urlTag;
        // if (self.subCollectionName) {
        //     self.urlString += "/" + self.subCollectionName;
        // }
      } else if (templateName == "search") {
        self.urlString =
          self.shopUrl +
          "/search?q=" +
          self.handle +
          "&options[prefix]=last&type=" +
          self.collectionOrder +
          "&view=json";
      }

    //  console.log("self ", self);

      self.productData = {};
      self.totalCounter = self.countOfData;
      self.manualCounter = 0;
      self.bestSellingCounter = 0;
      self.usualCounter = 0;

      if (self.noOfPages <= 0) {
        // removeFilterLoading();
        console.log("Operation terminated due to zero results");
      } else {
        self.initiateAjax();
      }
      self.setFilterHolder();
    }
  };

  P1.convergeData = function () {
    let self = this;
    PF.addEntry("ajax-end", "Ajax Ended");
    PF.measure("ajax-start", "ajax-end", "Ajax");

    self.productData = F.sortData(
      self.collectionOrder,
      __.toArray(self.productData)
    );
    resultsLoaded = true;
    stateChecker();
    D.data = self.productData;
    D.currentData = self.productData;
    console.log('self.filterHolder',self.filterHolder);
    const filteredFilterHoldert = Object.keys(self.filterHolder).reduce((acc, key) => {
      if (self.allowedFilters.includes(self.filterHolder[key].headerName)) {
        acc[key] = self.filterHolder[key];
      }
      return acc;
    }, {});
    D.createSideMenu(filteredFilterHoldert);
  };

  P1.processResults = function (parsedData, appendTo, pageNum) {
    let self = this;
    if (basicChecker(parsedData)) {
      let pageIndex = __.toNumber(pageNum) - 1;
      let orderNum = 0;
      if (pageIndex > 0) {
        orderNum = __.toNumber(pageIndex * self.paginateBy);
      }
      __.forEach(parsedData, function (prod, index) {
        orderNum++;
        let prodId = prod.id;

        if (!__.has(self.productData, prodId)) {
          __.set(prod, "ORD", 0);
          __.set(prod, "BST", 0);
          __.set(prod, "MNL", 0);

          self.setProductFilters(prod);

          __.set(self.productData, prodId, prod);
        }
        if (appendTo == "manual") {
          __.set(self.productData, [prodId, "MNL"], orderNum);
          self.manualCounter++;
        } else if (appendTo == "best-selling") {
          __.set(self.productData, [prodId, "BST"], orderNum);
          self.bestSellingCounter++;
        }
        if (appendTo == defaultOrder) {
          __.set(self.productData, [prodId, "ORD"], orderNum);
          self.usualCounter++;
        }
        if (index == parsedData.length - 1) {
          if (
            self.totalCounter == self.manualCounter &&
            self.totalCounter == self.bestSellingCounter &&
            self.totalCounter == self.usualCounter
          ) {
            self.convergeData();
          }
        } else if (parsedData.length == 0) {
          // removeFilterLoading();
        }
      });
    }
  };

  P1.processSearchResults = function (parsedData, pageNum) {
    let self = this;

    if (basicChecker(parsedData)) {
      let pageIndex = __.toNumber(pageNum) - 1;
      let orderNum = 0;
      if (pageIndex > 0) {
        orderNum = __.toNumber(pageIndex * self.paginateBy);
      }

      __.forEach(parsedData, function (prod, index) {
        orderNum++;
        let prodId = prod.id;
        if (!__.has(self.productData, prodId)) {
          self.setProductFilters(prod);
          __.set(self.productData, prodId, prod);
          self.usualCounter++;
        }
        if (index == parsedData.length - 1) {
          if (self.totalCounter == self.usualCounter) {
            self.convergeData();
          }
        }
      });
    }
  };

  P1.dataRetriever = function (pageUrl, appendTo, pageNum) {
    let self = this;

    fetch(pageUrl,{headers: {
      "Content-Type": "text/html; charset=utf-8",
    }}).then(response => response.json()).then(data => {
      if (appendTo == "search") {
        self.processSearchResults(data, pageNum);
      } else {
        self.processResults(data, appendTo, pageNum);
      }
    })
    .catch((error) => {
      console.log("FILTz error : Unable to complete Ajax Request", error.message);
    });
  };

  P1.initiateAjax = function () {
    let self = this;

    PF.addEntry("ajax-start", "Ajax Started");

    const arr = Array.from({ length: self.noOfPages }, (_, index) => index + 1);

    __.forEach(arr, function (m) {
      if (templateName == "collection") {
        /**
         * Get data in best-selling order
         */
        let ajaxUl =
          self.urlString + "?view=json&page=" + m + "&sort_by=best-selling";
        let appendTo = "best-selling";
        self.dataRetriever(ajaxUl, appendTo, m);

        /**
         * Get data in manual order
         */
        ajaxUl = self.urlString + "?view=json&page=" + m + "&sort_by=manual";
        appendTo = "manual";
        self.dataRetriever(ajaxUl, appendTo, m);

        /**
         * Get data in default order
         */
        if (
          self.collectionOrder != "manual" &&
          self.collectionOrder != "best-selling"
        ) {
          // console.log("ORDRRR => ", self.collectionOrder);
          ajaxUl =
            self.urlString +
            "?view=json&page=" +
            m +
            "&sort_by=" +
            self.collectionOrder;
          appendTo = self.collectionOrder;
          self.dataRetriever(ajaxUl, appendTo, m);
        }
      } else if (templateName == "search") {
        let ajaxUl = self.urlString + "&page=" + m;
        self.dataRetriever(ajaxUl, "search", m);
      }
    });
  };

  if (goAhead) {
    LSD.initiateProcess();
  }

  function basicChecker(ele) {
    return !__.isNil(ele) && ele != "" ? true : false;
  }

  function stateChecker() {
    PF.logInfo("StateChecker() called ");
    PF.logInfo("DOMLoaded " + domLoaded);
    PF.logInfo("jQueryLoaded " + jQueryLoaded);
    PF.logInfo("ResultsLoaded " + resultsLoaded);
    if (domLoaded && jQueryLoaded && resultsLoaded) {
      PF.logInfo("DOM, jQuery & Results are OK. So proceeding further...");
      F.data = LSD.productData;
    }
  }

  document.addEventListener("DOMContentLoaded", function (event) {
    jQueryLoaded = true;
    domLoaded = true;
    PF.addEntry("dom-ready", "DOM ready");
    PF.addEntry("jquery-ready", "jQuery ready");
    stateChecker();
  });
})();

(function ($, window, document, undefined) {
  function DOMEvents() {
    let self = this;

    PF.addEntry("dom-events-ready", "DOMEvents() [D] ready");

    if (__.isNil(filter_params)) {
      throw new Error("filter_params is required. Please provide.");
    }

    self.data = [];
    self.currentData = [];
    self.mapper = {};
    self.parentKeyMap = {};
    self.parentNameMap = {};
    self.isPopState = false;
    self.selectedFilters = {
      sort: false,
      page: false,
      productsPerPage: false,
      filters: [],
      others: [],
    };
    self.currentSort = defaultOrder;

    self.activeFilterClass = "selected-filter";
    self.activeFilterAttribute = "filter-class";

    self.getEmptyMenu = function () {
      return {
        headerName: "",
        headerKey: "",
        decodedKey: "",
        decodedName: "",
        subMenus: [],
      };
    };

    self.getEmptySubMenu = function () {
      return {
        subMenuName: "",
        subMenuKey: "",
        decodedSubMenuKey: "",
        decodedSubMenuName: "",
        class: "",
        referenceClass: "",
      };
    };

    self.getMapperObject = function () {
      return {
        parentKey: "",
        parentName: "",
        decodedParentKey: "",
        decodedParentName: "",
        subMenuKey: "",
        subMenuName: "",
        decodedSubMenuKey: "",
        decodedSubMenuName: "",
        event: "",
      };
    };

    self.productLoadingEle =
      !__.isNil(filter_params.product_loading_ele) &&
      __.isString(filter_params.product_loading_ele)
        ? filter_params.product_loading_ele
        : false;

    if (!self.productLoadingEle) {
      throw new Error(
        "Please provide an element to load the products as 'product_loading_ele' in parameters."
      );
    } else {
      if ($(self.productLoadingEle).length == 0) {
        throw new Error(
          "We are not able to find the " + self.productLoadingEle + " in DOM."
        );
      }
    }

    self.productProcessingEle =
      !__.isNil(filter_params.product_processing_ele) &&
      __.isString(filter_params.product_processing_ele)
        ? filter_params.product_processing_ele
        : false;

    if (!self.productProcessingEle) {
      throw new Error(
        "Please provide an element to load the products as 'product_processing_ele' in parameters."
      );
    } else {
      if ($(self.productProcessingEle).length == 0) {
        throw new Error(
          "We are not able to find the " +
            self.productProcessingEle +
            " in DOM."
        );
      }
    }

    let source = $(self.productProcessingEle).html();
    self.productProcessingEle = Handlebars.compile(source);

    self.menuLoadingEle =
      !__.isNil(filter_params.menu_loading_ele) &&
      __.isString(filter_params.menu_loading_ele)
        ? filter_params.menu_loading_ele
        : false;

    if (!self.menuLoadingEle) {
      throw new Error(
        "Please provide an element to load the side-menu as 'menu_loading_ele' in parameters."
      );
    } else {
      if ($(self.menuLoadingEle).length == 0) {
        throw new Error(
          "We are not able to find the " + self.menuLoadingEle + " in DOM."
        );
      }
    }

    self.productsPerBatch =
      !__.isNil(filter_params.products_per_page) &&
      __.isNumber(filter_params.products_per_page) &&
      filter_params.products_per_page > 0
        ? filter_params.products_per_page
        : 10;

    self.toggleClass =
      !__.isNil(filter_params.toggle_class) &&
      __.isString(filter_params.toggle_class) &&
      filter_params.toggle_class != ""
        ? filter_params.toggle_class
        : "";

    self.hasSort =
      !__.isNil(filter_params.sort_element) &&
      __.isString(filter_params.sort_element) &&
      filter_params.sort_element != ""
        ? filter_params.sort_element
        : false;
    if (self.hasSort) {
      if ($(self.hasSort).length == 0) {
        throw new Error(
          "Cannot find the element for sorting (" + self.hasSort + ") in DOM."
        );
      }
    }

    if (__.isNil(filter_params.menu)) {
      throw new Error("Please provide menu.");
    }
    if (!__.isObject(filter_params.menu)) {
      throw new Error("Please provide menu as an object.");
    }
    self.menu = filter_params.menu;

    if (__.isUndefined(self.menu.parent_starting_html)) {
      throw new Error('Please provide a "parent_starting_html" inisde menu.');
    }
    if (!__.isString(self.menu.parent_starting_html)) {
      throw new Error('"parent_starting_html" inisde menu must be a string.');
    }
    if (__.isUndefined(self.menu.parent_ending_html)) {
      throw new Error('Please provide a "parent_ending_html" inisde menu.');
    }
    if (!__.isString(self.menu.parent_ending_html)) {
      throw new Error('"parent_ending_html" inisde menu must be a string.');
    }
    if (__.isUndefined(self.menu.submenu_starting_html)) {
      throw new Error('Please provide a "submenu_starting_html" inisde menu.');
    }
    if (!__.isString(self.menu.submenu_starting_html)) {
      throw new Error('"submenu_starting_html" inisde menu must be a string.');
    }
    if (__.isUndefined(self.menu.submenu_ending_html)) {
      throw new Error('Please provide a "submenu_ending_html" inisde menu.');
    }
    if (!__.isString(self.menu.submenu_ending_html)) {
      throw new Error('"submenu_ending_html" inisde menu must be a string.');
    }
    if (__.isUndefined(self.menu.submenu_ending_html)) {
      throw new Error('Please provide a "submenu_ending_html" inisde menu.');
    }
    if (!__.isString(self.menu.submenu_ending_html)) {
      throw new Error('"submenu_ending_html" inisde menu must be a string.');
    }
    if (__.isUndefined(self.menu.submenu_html)) {
      throw new Error('Please provide a "submenu_html" inisde menu.');
    }
    if (!__.isString(self.menu.submenu_html)) {
      throw new Error('"submenu_html" inisde menu must be a string.');
    }

    self.customMenu =
      !__.isNil(filter_params.custom_menu) &&
      __.isObject(filter_params.custom_menu)
        ? filter_params.custom_menu
        : false;

    self.showCount =
      !__.isNil(filter_params.show_count) && __.isString(filter_params.show_count)
        ? filter_params.show_count
        : false;

    self.clearAllElement =
      !__.isNil(filter_params.clear_all_element) &&
      __.isString(filter_params.clear_all_element)
        ? filter_params.clear_all_element
        : false;

        //  console.log(self.clearAllElement);

    if (self.clearAllElement) {
      if ($(self.clearAllElement).length == 0) {
        throw new Error(
          "Cannot find the element for clearing all filters (" +
            self.clearAllElement +
            ") in DOM."
        );
      }
    }

    if (
      __.hasIn(filter_params, "active_filters") &&
      __.isObject(filter_params.active_filters) &&
      !__.isEmpty(filter_params.active_filters)
    ) {
      let active_filters = filter_params.active_filters;

      if (!__.hasIn(active_filters, "container")) {
        throw new Error(
          "Cannot find 'container' inside active_filters in filter_params."
        );
      } else {
        if ($(active_filters.container).length == 0) {
          throw new Error(
            "Cannot find the element for showing active/selected filters (" +
              active_filters.container +
              ") in DOM."
          );
        }
      }

      /*if (!__.hasIn(active_filters, "filters_holder")) {
        throw new Error(
          "Cannot find 'filters_holder' inside active_filters in filter_params."
        );
      } else {
        if ($(active_filters.filters_holder).length == 0) {
          throw new Error(
            "Cannot find the element for appending active/selected filters (" +
              active_filters.filters_holder +
              ") in DOM."
          );
        }
      }*/

      /*if (!__.hasIn(active_filters, "filter_element")) {
        throw new Error(
          "Cannot find 'filter_element' inside active_filters in filter_params."
        );
      }*/

      self.activeFilters = {
        container: active_filters.container,
        filtersHolder: active_filters.filters_holder,
        filterElement: active_filters.filter_element,
      };

      if (
        __.hasIn(active_filters, "clear_all_ele") &&
        __.isString(active_filters.clear_all_ele)
      ) {
        __.set(
          self.activeFilters,
          "clearAllElement",
          active_filters.clear_all_ele
        );
      }

      if (
        __.hasIn(active_filters, "close_btn_class") &&
        __.isString(active_filters.close_btn_class)
      ) {
        __.set(
          self.activeFilters,
          "filterCloseClass",
          active_filters.close_btn_class
        );
      }
    } else {
      self.activeFilters = false;
    }

    self.bindLoadMore = function () {
      $(window).bind(
        "scroll",
        __.debounce(function (e) {
          if (
            $(window).scrollTop() >=
            $(self.productLoadingEle).offset().top +
              $(self.productLoadingEle).outerHeight() -
              window.innerHeight
          ) {
            self.appendProducts();
          }
        }, 150)
      );
    };

    self.bindPagination = function () {
      let self = this;

      if (!__.hasIn(filter_params.pagination, "liquid_pagination_element")) {
        throw new Error(
          "Cannot find the 'liquid_pagination_element' for showing/hiding the liquid pagination in filter_params."
        );
      } else {
        if ($(filter_params.pagination.liquid_pagination_element).length == 0) {
          throw new Error(
            "We are not able to find the " +
              filter_params.pagination.liquid_pagination_element +
              " in DOM."
          );
        }
      }

      if (!__.hasIn(filter_params.pagination, "filtz_pagination_element")) {
        throw new Error(
          "Cannot find the 'filtz_pagination_element' for showing filtz pagination in filter_params."
        );
      } else {
        if ($(filter_params.pagination.filtz_pagination_element).length == 0) {
          throw new Error(
            "We are not able to find the " +
              filter_params.pagination.filtz_pagination_element +
              " in DOM."
          );
        }
      }

      if (!__.hasIn(filter_params.pagination, "pagination_template")) {
        throw new Error(
          "Cannot find the 'pagination_template' for showing pagination in filter_params."
        );
      } else {
        if ($(filter_params.pagination.pagination_template).length == 0) {
          throw new Error(
            "We are not able to find the " +
              filter_params.pagination.pagination_template +
              " in DOM."
          );
        }
      }

      self.pagination = {
        page: 1,
        liquidPaginationEle: filter_params.pagination.liquid_pagination_element,
        filtzPaginationEle: filter_params.pagination.filtz_pagination_element,
        displayedData: [],
        totalPages: 0,
        linkCount: 5,
        productsPerPage: self.productsPerBatch,
        template: Handlebars.compile(
          $(filter_params.pagination.pagination_template).html()
        ),
      };

      self.pagination.productsPerPageElement = __.hasIn(
        filter_params,
        "products_per_page_element"
      )
        ? filter_params.products_per_page_element
        : false;

      if (self.pagination.productsPerPageElement) {
        if ($(self.pagination.productsPerPageElement).length == 0) {
          throw new Error(
            "We are not able to find the " +
              self.pagination.productsPerPageElement +
              " in DOM."
          );
        }
      }

      $(self.pagination.filtzPaginationEle).on(
        "click",
        "[data-page]",
        function (e) {
          e.preventDefault();
          self.pageTriggered($(this).data("page"));
        }
      );

      if (self.pagination.productsPerPageElement) {
        $(self.pagination.productsPerPageElement).on("change", function (e) {
          e.preventDefault();
          if (!self.isPopState) {
            self.productsPerPageTriggered(__.parseInt($(this).val()));
          }
        });
      }
    };

    /**
     * Check if 'pagination' is provided as {}
     * If yes, pagination & products per page is considered
     * Else, we treat this as Ajax pagination
     * If pagination is OK,
     */
    self.hasPagination =
      !__.isNil(filter_params.pagination) && __.isObject(filter_params.pagination)
        ? true
        : false;

    if (self.hasPagination) {
      self.bindPagination();
    } else {
      self.bindLoadMore();
    }

    self.currentPage = self.hasPagination ? 1 : false;

    self.decode = function (str) {
      return __.toLower(decodeURIComponent(str)).split("_").join("-");
    };
  }

  let P3 = DOMEvents.prototype;
  if (goAhead) {
    this.D = new DOMEvents();
    PF.logInfo("DOMEvents() [D] initialized.");
  }

  P3.getUrlCollection = function () {
    let currentUrl = window.location.href;
    if (__.includes(currentUrl, "?")) {
      currentUrl = currentUrl.substring(0, currentUrl.indexOf("?"));
    }
    let urlArray = __.split(currentUrl, "/collections/");
    let trimmedArray = __.split(urlArray[1], "/");
    return typeof trimmedArray[0] !== "undefined" &&
      typeof trimmedArray[0] !== null &&
      trimmedArray[0] != ""
      ? trimmedArray[0]
      : "";
  };

  P3.filterTriggered = function (isSelected, className) {

    let self = this;

    if (isSelected) {
      self.selectedFilters.filters.push(className);
    } else {
      __.pull(self.selectedFilters.filters, className);
    }
    // console.log(self.selectedFilters.filters);
    /**
     * To update classes in filter-bar
     */
    self.updateFilterBar(isSelected, className);

    self.updateFilters("filters");
  };

  P3.sortTriggered = function () {
    // console.log( "inside sortTriggered");
    let self = this;

    if (!self.isPopState) {
    if($(self.hasSort).val()){
    self.selectedFilters.sort = $(self.hasSort).val();
    self.updateFilters('sort');
    }
    }
    };

  P3.pageTriggered = function (page) {
    let self = this;

    self.pagination.page = page;
    self.selectedFilters.page = page;
    self.updateFilters("page");
  };

  P3.productsPerPageTriggered = function (num) {
    let self = this;

    self.pagination.productsPerPage = num;
    self.selectedFilters.productsPerPage = num;
    self.updateFilters("productsPerPage");
  };

  P3.popStateTriggered = function () {
    let self = this;

    self.updateFilters("popstate");
  };

  P3.checkUrlFilters = function () {
    let self = this;

    self.updateFilters("urlLoaded");
  };

  P3.updateFilters = function (event) {


    let self = this;

    PF.addEntry(
      "update-filter-start",
      "Checking Filters for (" + event + ") starts at"
    );

    let urlFilters = {};
    switch (event) {
      case "urlLoaded":
        $.when(self.getFiltersFromUrl())
        .then(self.setFiltersFromUrl())
        .then(function () {
          let urlFilters = self.urlHolder;
          if (!__.isEmpty(urlFilters.others)) {
            otherUrlArray = [];
            __.forEach(urlFilters.others, function (val, key) {
              let otherUrl = key + '=' + val;
              if (__.indexOf(otherUrlArray, key) === -1) {
                otherUrlArray.push(otherUrl);
              }
            });
            __.set(self.selectedFilters, 'others', otherUrlArray);
          }
          PF.logInfo('Filters from URL is ' + JSON.stringify(urlFilters));
          if (self.hasSort) {
            if (!urlFilters['sort-by']) {
              // self.selectedFilters.sort = defaultOrder;
            } else {
              self.selectedFilters.sort = urlFilters['sort-by'];
            }
            if (self.selectedFilters.sort != $(self.hasSort).val()) {
              if(self.selectedFilters.sort){
                $(self.hasSort).val(self.selectedFilters.sort).change();
              }else{
                $(self.hasSort).val(defaultOrder);
              }
            }
          }
          if (self.hasPagination) {
            if (!urlFilters['page']) {
              // self.selectedFilters.page = 1;
            } else {
              self.selectedFilters.page = urlFilters['page'];
            }
            if (self.pagination.page != self.selectedFilters.page) {
              self.pagination.page = self.selectedFilters.page;
            }
          }
          console.log('urlFilters',urlFilters);
          console.log('urlFilters inner',urlFilters.filters);
          if(Object.keys(urlFilters.filters).length > 0){
            $(self.clearAllElement).show();
          }else{
            $(self.clearAllElement).hide();
          }
          if (!__.isEmpty(urlFilters.filters) || urlFilters["sort-by"] || urlFilters.page || !__.isEmpty(urlFilters.others)) {
            console.log('filterApplied',filterApplied);
            $.when(self.createInitialFilter(urlFilters)).then(function () {
              // if (filterApplied > 0) {
                $.when(self.initiateFilter()).then(self.pushToHistory());
              // }
            });
          }
        });
      break;

      case "filters":
        // console.log("triggered");
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory()).then(self.updateFilterBar());
        break;

      case "clearAllFilters":
        // console.log("inside clear all switch");
        filterApplied++;
        $.when(self.initiateFilter()).then(self.updateFilterBar()).then(self.pushToHistory());
        break;

      case "sort":
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case "page":
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case "productsPerPage":
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case "popstate":
        $.when(self.getFiltersFromUrl())
					.then(self.setFiltersFromUrl())
					.then(function () {
						let urlFilters = self.urlHolder;
						PF.logInfo('Filters from URL is ' + JSON.stringify(urlFilters));

						self.isPopState = true;
						let filterClasses = self.getClasses(urlFilters.filters);
						self.selectedFilters.filters = filterClasses;
						if (self.hasSort) {
							if (!urlFilters['sort-by']) {
								self.selectedFilters.sort = defaultOrder;
							} else {
								self.selectedFilters.sort = urlFilters['sort-by'];
							}
							if (self.selectedFilters.sort != $(self.hasSort).val()) {
								$(self.hasSort).val(self.selectedFilters.sort).change();
							}
						}
						if (self.hasPagination) {
							if (!urlFilters['page']) {
								self.selectedFilters.page = 1;
							} else {
								self.selectedFilters.page = urlFilters['page'];
							}
							if (self.pagination.page != self.selectedFilters.page) {
								self.pagination.page = self.selectedFilters.page;
							}
						}

						filterApplied++;
						$.when(self.initiateFilter())
							.then(self.updateFilterBar())
							.then(function () {
								self.isPopState = false;
							});
					});
				break;

      default:
        break;
    }

    PF.addEntry(
      "update-filter-end",
      "Checking Filters for (" + event + ") ends at"
    );
    PF.measure("update-filter-start", "update-filter-end", "Filtering");
  };

  P3.createInitialFilter = __.memoize(function (urlFilters) {
    // console.log(urlFilters);
    let self = this;

    let hasFilter = false;
    // console.log("-- createInitialFilter() --");
    if (!__.isEmpty(urlFilters.filters)) {
      __.forEach(urlFilters.filters, function (values, key) {
        __.forEach(values, function (v, k) {
          let className = self.getClassFromMapper(key, v);
          if (className) {
            $("." + className).find('input[type="checkbox"]').prop('checked', true);
            $("." + className).addClass(baseToggleClass + " " + self.toggleClass);
            // $("." + className).removeClass('fa fa-square');
            // $("." + className).addClass('fa fa-check-square');
            self.selectedFilters.filters.push(className);
            hasFilter = true;
          }
        });
      });
    }
    if (hasFilter) {
      filterApplied++;
    }
    // console.log("-- createInitialFilter ended --");
  });

  P3.updateFilterBar = function () {
    let self = this;

    let isSelected =
      arguments.length > 0 && !__.isNil(arguments[0]) ? arguments[0] : false;
    let className =
      arguments.length > 1 && !__.isNil(arguments[1]) ? arguments[1] : false;

    if (className) {
      if (isSelected) {
        $("." + className).addClass(baseToggleClass + " " + self.toggleClass);
        // $("." + className).removeClass('fa fa-square');
        // $("." + className).addClass('fa fa-check-square');
      } else {
        $("." + className).removeClass(
          baseToggleClass + " " + self.toggleClass
        );
        // $("." + className).removeClass('fa fa-check-square');
        // $("." + className).addClass('fa fa-square');
      }
    } else {
          // console.log("==========================");
          // console.log("going to tick the check box");
          // console.log("==========================");
      __.forEach(self.mapper, function (val, key) {
        if (__.indexOf(self.selectedFilters.filters, key) === -1) {
          $("." + key).removeClass(baseToggleClass + " " + self.toggleClass);
          $("." + key).find('input').prop('checked',false);
          // $("." + key).removeClass('fa fa-check-square');
          // $("." + key).addClass('fa fa-square');
        } else {
          $("." + key).addClass(baseToggleClass + " " + self.toggleClass);
          $("." + key).find('input').prop('checked',true);
          // $("." + className).removeClass('fa fa-square');
          // $("." + className).addClass('fa fa-check-square');
        }
      });
    }
  };

  P3.bindEvents = function () {
    let self = this;

    PF.addEntry("binding-start", "Started binding events at");

    __.forEach(self.mapper, function (value, key) {
      let $ele = $("." + key);
      $("." + key).click(function () {
        let isSelected =
          __.indexOf(self.selectedFilters.filters, key) == -1 ? true : false;
        self.filterTriggered(isSelected, key);
      });
    });
    // console.log(self.hasSort);
    if (self.hasSort) {
      $(self.hasSort).change(function (event) {
        self.sortTriggered();
      });
    }

    window.onpopstate = function (event) {
      self.popStateTriggered();
    };
    testArray=[];
    if (self.clearAllElement) {
      console.log(self.selectedFilters);
      testArray.push(self.selectedFilters);
      console.log(testArray);
      $(self.clearAllElement)
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          console.log(testArray);
          __.set(self.selectedFilters, "filters", []);
          self.updateFilters("clearAllFilters");
        });
    }

    PF.addEntry("binding-end", "Done binding events at ");
    PF.measure("binding-start", "binding-end", "BindingEvents");
  };

	P3.createFilterParams = function () {
		let self = this;

		let params = {};
		let currentFilters = __.get(self.selectedFilters, 'filters');

		__.forEach(currentFilters, function (className) {
			let credentials = __.get(self.mapper, className);

			if (!__.hasIn(params, credentials.parentKey)) {
				__.set(params, credentials.parentKey, []);
			}
			if (
				__.indexOf(params[credentials.parentKey], credentials.subMenuKey) == -1
			) {

					params[credentials.parentKey].push(credentials.subMenuKey);

			} else {
			}
		});

		return params;
	};
  P3.initiateFilter = __.debounce(
    function () {
      let self = this;

      PF.addEntry("filtz-initiate", "Filtz initiated at");
      console.log('filterApplied',filterApplied);
      // if (filterApplied > 0) {
        let filterParams = self.createFilterParams();
        let products = __.isEmpty(filterParams)
          ? self.data
          : F.filterData(self.data, filterParams);

        if (self.hasSort && self.selectedFilters.sort) {
          let sortVal = self.selectedFilters.sort;
          if (!__.isNil(sortVal)) {
            products = F.sortData(sortVal, products);
          }
        }

        if(Object.keys(self.selectedFilters.filters).length > 0){
          $(self.clearAllElement).show();
        }else{
          $(self.clearAllElement).hide();
        }

        self.currentData = products;
        if (self.hasPagination) {
          // console.log("--- Has Pagination ----");
          console.log("Current page - ", self.pagination.page);
          $.when(self.initPagination())
            .then(self.generateProductMarkup(self.pagination.displayedData))
            .then(self.setCount())
            .then(function () {
              if (self.activeFilters) {
                self.renderActiveFilters();
              }
            })
            .then(afterFilter(self.currentData));
        } else {
          let sliced = __.slice(
            self.currentData,
            currentDisplayedCount,
            currentDisplayedCount + self.productsPerBatch
          );
          $.when(self.generateProductMarkup(sliced))
            .then(self.setCount())
            .then(function () {
              if (self.activeFilters) {
                self.renderActiveFilters();
              }
            })
            .then(afterFilter(self.currentData));
        }
      // }

      PF.addEntry("filtz-conclude", "FILTz applied at ");
      PF.measure("filtz-initiate", "filtz-conclude", "FILTzApplying");
    },
    250,
    { maxWait: 2000 }
  );

  P3.generateProductMarkup = function (data) {
    let self = this;

    PF.addEntry(
      "product-generation-start",
      "Product markup generation starts at"
    );

    try {
      let isAppend =
        arguments.length > 1 && arguments[1] == "append" ? true : false;
      if (!isAppend) {
        $(self.productLoadingEle).empty();
        currentDisplayedCount = 0;
      }

      __.forEach(data, function (value) {
        let productHtml = self.productProcessingEle(value);
        $(self.productLoadingEle).append(productHtml);
        currentDisplayedCount++;
      });
      $(self.productLoadingEle).show();
      if(currentDisplayedCount <= 4){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
      // console.log("Displayed count -- " + currentDisplayedCount);
    } catch (err) {
      console.log(" -------- ERROR ------- ", err);
    }

    PF.addEntry("product-generation-end", "Products markup generated at ");
    PF.measure(
      "product-generation-start",
      "product-generation-end",
      "ProductGeneration"
    );
  };

  P3.appendProducts = function () {
    let self = this;

    PF.addEntry("append-start", "Appending data at");
    PF.logInfo("Current products (displayed) : " + currentDisplayedCount);
    PF.logInfo("Current products (all) : " + self.currentData.length);

    let sliced = __.slice(
      self.currentData,
      currentDisplayedCount,
      currentDisplayedCount + self.productsPerBatch
    );
    if (sliced.length > 0) {
      $.when(self.generateProductMarkup(sliced, "append")).then(
        afterAppend(sliced)
      );
    }

    PF.addEntry("append-end", "Appended data at ");
    PF.measure("append-start", "append-end", "AppendData");
  };

  P3.setCount = function () {
    let self = this;

    PF.addEntry("count-start", "Starting to set count at");

    __.forEach(self.mapper, function (value, key) {
      let filterKey = value.parentKey;
      let filterValue = value.subMenuKey;
      let count = __.toInteger(
        __.size(
          __.filter(self.currentData, function (val, k) {
            return __.hasIn(val.filters, filterKey) &&
              __.indexOf(val.filters[filterKey], filterValue) !== -1
              ? true
              : false;
          })
        )
      );
      if (self.showCount) {
        let countText = parseInt(count) > 0 ? "(" + parseInt(count) + ")" : "";
        $("." + key)
          .find("." + countClass)
          .text(countText);
      }
    });

    PF.addEntry("count-end", "Set count at ");
    PF.measure("count-start", "count-end", "SetCount");
  };

  P3.pushToHistory = function () {
    let self = this;

    let newUrl = self.createUrlString();
    PF.logInfo("New URL created at pushToHistory() - " + newUrl);
    if(newUrl!='?'){
      history.pushState({}, '', newUrl);
    }else{
      let currentUrl = window.location.href;
      currentUrl = currentUrl.substring(0, currentUrl.indexOf('?'));
      history.pushState({}, '', currentUrl);
    }
  };

	P3.getFiltersFromUrl = function () {
		var self = this;

		self.urlHolder = {
			filters: {},
			'sort-by': false,
			page: false,
			others: {},
			'products-per-page': false,
		};

		var pairs = document.location.search.replace('?', '').split('&');

    if(document.location.pathname.indexOf('/collections/digital-tab-books') !== -1 && document.location.search.indexOf('formats=') === -1){
      pairs.push('formats=digital');
    }

    let instrument = document.location.pathname.split('/').pop();
    let instrumentFilter = __.findKey(self.mapper, menu => (menu.parentKey == "instrument" && menu.subMenuKey.toLowerCase()==instrument));
    if(instrumentFilter){
      $('.'+instrumentFilter).trigger('click');
    }

    pairs = __.filter(pairs, function (pair, index) {
      let query = pair.split('=');
      if(!query[0].startsWith("_")){
        return query;
      }
    });
    pairs = __.map(pairs, function (pair, index) {
      return pair.split('=');
    });
    if(inStockFlag && pairs.length <= 0){
      pairs.push(['stock_status','in-stock']);
    }else if(inStockFlag && pairs.length == 1 && ((pairs[0].length == 1 && (pairs[0][0]=='')) || (pairs[0].length < 1))){
      pairs.push(['stock_status','in-stock']);
    }

    console.log('filts', pairs[0]);

		__.forEach(pairs, function (pair, index) {
			if (
				typeof pair[0] !== 'undefined' &&
				__.isString(pair[0]) &&
				pair[0] != ''
			) {
				var key = self.decode(pair[0]);
				if (__.indexOf(excludedUrlFilters, key) !== -1) {
					if (!__.hasIn(self.urlHolder.others, key)) {
						__.set(self.urlHolder.others, key, []);
					}
					if (
						typeof pair[1] !== 'undefined' &&
						__.isString(pair[1]) &&
						pair[1] != ''
					) {
						var value = self.decode(pair[1]);
						if (__.indexOf(self.urlHolder.others[key], value) === -1) {
							self.urlHolder.others[key].push(value);
						}
					}
				} else if (key == 'sort-by') {
					if (
						typeof pair[1] !== 'undefined' &&
						__.isString(pair[1]) &&
						pair[1] != ''
					) {
						var value = self.decode(pair[1]);
						self.urlHolder['sort-by'] = value;
					}
				} else if (key == 'page') {
					if (
						typeof pair[1] !== 'undefined' &&
						__.isString(pair[1]) &&
						pair[1] != ''
					) {
						var value = parseInt(self.decode(pair[1]));
						self.urlHolder['page'] = value;
					}
				} else if (key == 'products-per-page') {
					if (
						typeof pair[1] !== 'undefined' &&
						__.isString(pair[1]) &&
						pair[1] != ''
					) {
						var value = parseInt(self.decode(pair[1]));
						self.urlHolder['products-per-page'] = value;
					}
				} else {
					if (!__.hasIn(self.urlHolder.filters, key)) {

						__.set(self.urlHolder.filters, key, []);
					}
					if (
						typeof pair[1] !== 'undefined' &&
						__.isString(pair[1]) &&
						pair[1] != ''
					) {
						var value = self.decode(pair[1]);
						if (__.indexOf(self.urlHolder.filters[key], value) === -1) {
							self.urlHolder.filters[key].push(value);
						}
					}
				}
			}
		});
    //console.log(self.urlHolder);
	};

  P3.setFiltersFromUrl = function () {
		let self = this;
		let urlHolder = self.urlHolder;
    // console.log(self.parentKeyMap);
    // console.log(self.parentNameMap);
    // console.log(urlHolder.filters);
		if (!__.isEmpty(urlHolder)) {
			__.forEach(urlHolder.filters, function (val, key) {
				if (
					!__.hasIn(self.parentKeyMap, key) &&
					!__.hasIn(self.parentNameMap, key)
				) {
					__.unset(urlHolder.filters, key);
				} else {
					let availableValues = [];
					if (__.hasIn(self.parentNameMap, key)) {
						availableValues = __.keys(__.get(self.parentNameMap, key));
					} else if (__.hasIn(self.parentKeyMap, key)) {
						availableValues = __.keys(__.get(self.parentKeyMap, key));
					}
          console.log(availableValues);
					let invalidValues = __.difference(val, availableValues);
					if (invalidValues.length > 0) {
						let updatedValues = __.pullAll(val, invalidValues);
						__.set(urlHolder.filters, key, updatedValues);
					}
				}
			});
		}
		self.urlHolder = urlHolder;
    //  console.log(self.urlHolder);
	};


  P3.createUrlString = function () {
    let self = this;
    let str = "";
    if (!__.isEmpty(self.selectedFilters.filters)) {
      let currentFilters = self.selectedFilters.filters;
      str = __.map(self.selectedFilters.filters, function (values, key) {
        let filterObj = __.get(self.mapper, values);
        return (
          encodeURIComponent(filterObj.decodedParentName) +
          "=" +
          encodeURIComponent(filterObj.decodedSubMenuName)
        );
      }).join("&");
    }

    if (self.hasSort && self.selectedFilters.sort) {
      str +=
        str == ""
          ? "sort-by=" + self.selectedFilters.sort
          : "&sort-by=" + self.selectedFilters.sort;
    }

    if (self.hasPagination && self.selectedFilters.page) {
      str +=
        str == ""
          ? "page=" + self.selectedFilters.page
          : "&page=" + self.selectedFilters.page;
    }

    if (
      self.pagination.productsPerPageElement &&
      self.selectedFilters.productsPerPage
    ) {
      str +=
        str == ""
          ? "products-per-page=" + self.selectedFilters.productsPerPage
          : "&products-per-page=" + self.selectedFilters.productsPerPage;
    }

    if (self.selectedFilters.others.length > 0) {
      str +=
        str == ""
          ? self.selectedFilters.others.join("&")
          : "&" + self.selectedFilters.others.join("&");
    }

    return "?" + str;
  };

  P3.getClassFromMapper = function (header, sub) {
    let self = this;

    let className = false;

    __.forEach(self.mapper, function (n, key) {
      if (
        (header == n.decodedParentKey || header == n.decodedParentName) &&
        (sub == n.decodedSubMenuKey || sub == n.decodedSubMenuName)
      ) {
        className = key;
        return false;
      }
    });

    return className;
  };

  P3.getClasses = function (data) {
    let self = this;

    let classes = __.map(data, function (val, key) {
      let cls = [];
      if (__.hasIn(self.parentNameMap, key)) {
        cls = __.map(val, function (v, k) {
          let className = self.parentNameMap[key][v];
          return self.parentNameMap[key][v];
        });
      } else if (__.hasIn(self.parentKeyMap, key)) {
        cls = __.map(val, function (v, k) {
          let className = self.parentNameMap[key][v];
          return self.parentKeyMap[key][v];
        });
      }
      return !__.isEmpty(cls) ? cls : false;
    });

    return __.uniq(__.compact(__.flattenDeep(classes)));
  };

  P3.renderActiveFilters = function () {
    let self = this;

    PF.addEntry("active-filter-start", "Starting to set active filters");
    $(self.activeFilters.filtersHolder).empty();
    // if($(self.activeFilters.filtersHolder).empty())
    // {
    //   console.log("inside empty");
    // }
    // console.log(self.selectedFilters.filters);
    filterCount = (self.selectedFilters.filters).length; // filterCount get no of filter applied.
    filterCount = (filterCount ? filterCount : 0);
    if(filterCount < 1 )
    {
      $("#filtz__clear-all-button").hide();
    }else{
      $("#filtz__clear-all-button").show();
    }
    if (__.isEmpty(self.selectedFilters.filters)) {
      // $(self.activeFilters.container).hide();
    } else {
      let htmlString = "";
      /*__.forEach(self.selectedFilters.filters, function (val, key) {
        let filterDetails = __.get(self.mapper, val);
        // console.log(filterDetails);
        // count = count+1;
        let filterElement = self.activeFilters.filterElement;
        let htmlEle = self.stringReplace(
          filterElement,
          "@filter_header",
          filterDetails.parentName
        );

        htmlEle = self.stringReplace(
          htmlEle,
          "@filter_value",
          filterDetails.subMenuName
        );
        let $htmlEle = $(htmlEle);
        $htmlEle.addClass(self.activeFilterClass);
        $htmlEle.attr(self.activeFilterAttribute, val);

        htmlString += self.htmlToString($htmlEle);
        // console.log(htmlString);
      });*/

      if (htmlString !== "") {
        $(self.activeFilters.container)
          .show()
          .find(self.activeFilters.filtersHolder)
          .empty()
          .append(htmlString);

        /**
         * Binding events to close filters
         */
        if (__.hasIn(self.activeFilters, "filterCloseClass")) {
          $(self.activeFilters.container)
            .off("click")
            .on("click", "." + self.activeFilters.filterCloseClass, function (
              e
            ) {
              e.preventDefault();

              let classAttribute = $(this)
                .closest(self.activeFilterClass)
                .attr(self.activeFilterAttribute);
                // console.log(classAttribute);
              if (__.isUndefined(classAttribute)) {
                console.log("undefined");
                classAttribute = $(this).attr(self.activeFilterAttribute);
              }
              console.log(classAttribute);
              $(self.menuLoadingEle)
                .find("." + classAttribute)
                .trigger("click");
            });
        }
      }
    }

    if (self.activeFilters.clearAllElement) {
      $(self.activeFilters.clearAllElement)
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          __.set(self.selectedFilters, 'filters', []);
          self.updateFilters("clearAllFilters");
        });
    }
    PF.addEntry("active-filter-end", "Active filters set at ");
    PF.measure("active-filter-start", "active-filter-end", "SetActiveFilter");
  };

  P3.htmlToString = function (htmlEle) {
    let self = this;

    let htmlStr = "";
    for (let m = 0; m < htmlEle.length; m++) {
      htmlStr += htmlEle[m]["outerHTML"];
    }
    return htmlStr;
  };

  P3.stringReplace = function (str, src, rep) {
    let self = this;

    if (__.isObject(str)) {
      str = JSON.stringify(str);
    }
    str = str.toString();
    str = str.split(src).join(rep);
    return str;
  };

  P3.getSideMenu = function (key) {
    let self = this;

    let menu = {
      parentStart: "",
      parentEnd: "",
      subMenuStart: "",
      subMenuEnd: "",
      subMenu: "",
    };
    if (self.customMenu && __.hasIn(self.customMenu, key)) {
      let customMenu = __.get(self.customMenu, key);
      menu.parentStart =
        __.hasIn(customMenu, "parent_starting_html") &&
        __.isString(customMenu.parent_starting_html)
          ? customMenu.parent_starting_html
          : self.menu.parent_starting_html;
      menu.parentEnd =
        __.hasIn(customMenu, "parent_ending_html") &&
        __.isString(customMenu.parent_ending_html)
          ? customMenu.parent_ending_html
          : self.menu.parent_ending_html;
      menu.subMenuStart =
        __.hasIn(customMenu, "submenu_starting_html") &&
        __.isString(customMenu.submenu_starting_html)
          ? customMenu.submenu_starting_html
          : self.menu.submenu_starting_html;
      menu.subMenuEnd =
        __.hasIn(customMenu, "submenu_ending_html") &&
        __.isString(customMenu.submenu_ending_html)
          ? customMenu.submenu_ending_html
          : self.menu.submenu_ending_html;
      menu.subMenu =
        __.hasIn(customMenu, "submenu_html") &&
        __.isString(customMenu.submenu_html)
          ? customMenu.submenu_html
          : self.menu.submenu_html;
    } else {
      menu.parentStart = self.menu.parent_starting_html;
      menu.parentEnd = self.menu.parent_ending_html;
      menu.subMenuStart = self.menu.submenu_starting_html;
      menu.subMenuEnd = self.menu.submenu_ending_html;
      menu.subMenu = self.menu.submenu_html;
    }

    return menu;
  };

  /**
   * ======================
   * Pagination ***********
   * ======================
   */
   P3.initPagination = function () {
    let self = this;

    // console.log("===== Init Pagination called ======");

    let selectedPage = self.pagination.page

    let paginated = self.getPaginatedData(
      self.currentData,
      self.pagination.page,
      self.pagination.productsPerPage
    );
    // console.log("Pagination count - " + self.pagination.productsPerPage);
    console.log("Paginated data ", paginated);
    if (paginated.page > paginated.totalPages) {
      paginated.page = paginated.totalPages;
    }

      self.pagination.displayedData = paginated.data;
      self.pagination.page = paginated.page;
      self.pagination.totalPages = paginated.totalPages;
      self.pagination.totalCount = self.currentData.length;

      if (self.pagination.totalPages > 1) {
        let links = self.createPaginationLinks();
        __.set(links, "page", paginated.page);
        __.set(links, "totalPages", paginated.totalPages);
        self.renderPaginationLinks(links);
      } else {
        $(filter_params.pagination.filtz_pagination_element).hide();
      }
  };

  P3.getPaginatedData = function (items, page, pageSize) {
    var pg = page || 1,
      pgSize = pageSize || 100,
      offset = (pg - 1) * pgSize,
      pagedItems = __.drop(items, offset).slice(0, pgSize);

      if (!pagedItems.length) {
        (pg = 1),
          (pgSize = pageSize || 100),
          (offset = (pg - 1) * pgSize),
          (pagedItems = __.drop(items, offset).slice(0, pgSize));
      }

    return {
      page: pg,
      pageSize: pgSize,
      total: items.length,
      totalPages: Math.ceil(items.length / pgSize),
      data: pagedItems,
    };
  };

  P3.createPaginationLinks = function () {
    let self = this;

    let currentPage = self.pagination.page;
    let totalPage = self.pagination.totalPages;
    let size = self.pagination.linkCount;
    let startCount = 0;
    let endCount = 0;
    let startPage, endPage, context, previousPage, nextPage;

    // console.log(currentPage , totalPage ,size);
    startPage = currentPage - Math.floor(size / 2);
    endPage = currentPage + Math.floor(size / 2);
    // console.log('startpage1=',startPage,'endpage1=',endPage);
    previousPage = currentPage <= 1 ? false : parseInt(currentPage) - 1;
    nextPage = currentPage >= totalPage ? false : parseInt(currentPage) + 1;

    if (startPage <= 0) {
      endPage -= startPage - 1;
      startPage = 1;
    }
    // console.log('startpage2=',startPage,'endpage2=',endPage);
    if (endPage > totalPage) {
      endPage = totalPage;
      if (endPage - size + 1 > 0) {
        startPage = endPage - size + 1;
      } else {
        startPage = 1;
      }
    }

    context = {
      startFromFirstPage: false,
      pages: [],
      endAtLastPage: false,
      nextPage: nextPage,
      previousPage: previousPage,
      lastDots: false,
      displayLastNumber: false,
      startingDots: false,
      totalCount: self.pagination.totalCount,
      startCount :0,
      endCount : 0, 
    };

    if (previousPage == 0){
      context.startCount = 1;
    } else {
      context.startCount  = ((currentPage-1) * 12) + 1;
    }

    if (startPage === 1) {
      context.startFromFirstPage = true;
    } else {
      context.previousPage = currentPage - 1;
    }
    if (endPage == totalPage - 1) {
			context.displayLastNumber = true;
		}
    if (startPage >= 3) {
      context.startingDots = true;
    }
		if (endPage <= totalPage - 3) {
			context.lastDots = true;
		}

    for (let i = startPage; i <= endPage; i++) {
      context.pages.push({
        page: i,
        isCurrent: i === currentPage,
      });
    }

    // if (endPage === totalPage) {
    //   context.endAtLastPage = true;
    // } else {
    //   context.nextPage = currentPage + 1;
    // }
    if (currentPage === totalPage) {
      context.endAtLastPage = true;
      context.endCount = self.pagination.totalCount;
    } else {
      context.endCount = ((currentPage) * 12)
    }
    // console.log(context);
    return context;
  };

  P3.renderPaginationLinks = function (links) {
    // console.log(links);
    let self = this;

    let template = self.pagination.template;
    let paginationEle = template(links);

    $.when($(self.pagination.liquidPaginationEle).hide()).then(
      $(self.pagination.filtzPaginationEle).show().empty().append(paginationEle)
    );
  };

  P3.createSideMenu = function (filters) {
    let self = this;
    let urlCollection = self.getUrlCollection();

    if (devMode) {
      PF.addEntry("filter-bar-start", "Started creating filter-bar at");
    }

    let orderedkeys = __.map(
      __.sortBy(filters, ["orderNumber", "headerName"]),
      "headerKey"
    );
    orderedkeys = __.compact(orderedkeys);
    let finalMenu = [];
    let classCounter = 1;
    let isArtistCollection = false;
    $.when(
      __.forEach(orderedkeys, function (key) {
        let skpArtistFlag = false;
        let filter = __.get(filters, key);
        if(urlCollection == 'accessories' && key == 'Size'){
          return;
        }
        if(urlCollection == 'anthologies' && key == 'string_count'){
          return;
        }
        if (__.hasIn(filter, "hasSubMenus") && filter.hasSubMenus) {
          let decodedParentKey = self.decode(key);
          let decodedParentName = self.decode(filter.headerName);

          let menuObj = self.getEmptyMenu();
          menuObj.headerName = filter.headerName;
          menuObj.headerKey = key;
          menuObj.decodedKey = decodedParentKey;
          menuObj.decodedName = decodedParentName;

          if (key == 'artist') {
            orderedSubMenukeys = __.map(
              __.sortBy(filter.subMenus, ['orderNumber', 'subMenuName']),
              'subMenuKey',
            );
            // this make sure that only the current artist being viewed
            // is the one in the orderedSubMenukeys array
            if (
              orderedSubMenukeys.length > 1 &&
              (urlCollection != 'merch' &&
                urlCollection != 'accessories' &&
                urlCollection != 'vinyl' &&
                urlCollection != 'prints' &&
                urlCollection != 'bundles' &&
                urlCollection != 'books' &&
                urlCollection != 'anthologies')
            ) {
              const currentArtist = self.currentData[0].MET_NAME.trim();
              orderedSubMenukeys = [currentArtist];
            }
            if (orderedSubMenukeys.length == 1) {
              let artistName = orderedSubMenukeys
                .pop()
                .replace(/[^a-zA-Z ]/g, '')
                .replace(/ +/g, '-')
                .toLowerCase();
              if (artistName == resultHandle) {
                skpArtistFlag = true;
                isArtistCollection = true;
              }
            }
          } else {
            orderedSubMenukeys = __.map(
              __.sortBy(filter.subMenus, ["orderNumber", "subMenuName"]),
              "subMenuKey"
            );

          }
          orderedSubMenukeys = __.compact(orderedSubMenukeys);
          __.forEach(orderedSubMenukeys, function (subKey) {
            let subFilter = __.get(filter.subMenus, subKey);
            if(key=='stock_status' && subKey=='in_stock' && isArtist=='false' && !__.includes(filter_params.disable_stock_status_collection, collectionHandle)){
              inStockFlag = true;
            }
            if (subFilter.counter > 0) {
              let encodedSubMenuKey = encodeURI(subKey);
              let decodedSubMenuKey = self.decode(encodedSubMenuKey);
              let encodedSubMenuName = encodeURI(subFilter.subMenuName);
              let decodedSubMenuName = self.decode(encodedSubMenuName);
              let referenceClass = "filtz__ref-" + classCounter;
              classCounter++;

              let subMenuObj = self.getEmptySubMenu();
              subMenuObj.subMenuName = subFilter.subMenuName.replace(/\_/g,' ');
              if (key == 'Buying Options') {
                let prevOptionName = subMenuObj.subMenuName;
                if(prevOptionName.toLowerCase() != 'printed' && prevOptionName.toLowerCase() != 'digital' && prevOptionName.toLowerCase() != 'includes jam track'){
                  return;
                }
                if( referenceClass == 'filtz__ref-7' || referenceClass == 'filtz__ref-10' ){
                  return;
                }
              }
              subMenuObj.subMenuKey = subKey;
              subMenuObj.class = filterClass;
              subMenuObj.decodedSubMenuKey = decodedSubMenuKey;
              subMenuObj.decodedSubMenuName = decodedSubMenuName;
              subMenuObj.referenceClass = referenceClass;
              menuObj.subMenus.push(subMenuObj);

              if (!__.hasIn(self.mapper, subMenuObj.referenceClass)) {
                let mapperObj = self.getMapperObject();
                __.set(mapperObj, "parentName", menuObj.headerName);
                __.set(mapperObj, "parentKey", menuObj.headerKey);
                __.set(mapperObj, "decodedParentKey", decodedParentKey);
                __.set(mapperObj, "decodedParentName", decodedParentName);
                __.set(mapperObj, "subMenuKey", subKey);
                __.set(mapperObj, "subMenuName", subFilter.subMenuName);
                __.set(mapperObj, "decodedSubMenuKey", decodedSubMenuKey);
                __.set(mapperObj, "decodedSubMenuName", decodedSubMenuName);
                __.set(self.mapper, referenceClass, mapperObj);
              }

              if (!__.hasIn(self.parentKeyMap, decodedParentKey)) {
                __.set(self.parentKeyMap, decodedParentKey, {});
              }
              if (
                !__.hasIn(self.parentKeyMap[decodedParentKey], decodedSubMenuKey)
              ) {
                __.set(
                  self.parentKeyMap[decodedParentKey],
                  decodedSubMenuKey,
                  referenceClass
                );
              }

              if (!__.hasIn(self.parentNameMap, decodedParentName)) {
                __.set(self.parentNameMap, decodedParentName, {});
              }
              if (
                !__.hasIn(
                  self.parentNameMap[decodedParentName],
                  decodedSubMenuName
                )
              ) {
                __.set(
                  self.parentNameMap[decodedParentName],
                  decodedSubMenuName,
                  referenceClass
                );
              }
            }
          });
          if(!skpArtistFlag){
            finalMenu.push(menuObj);
          }
        }
      })
    )
      .then(function () {
        $(self.menuLoadingEle).empty();
        let headerCount = 0;
        let menuCount = 0;
        if (self.showCount) {
          self.showCount = self.stringReplace(
            self.showCount,
            "@count_class",
            countClass
          );
        }
        __.forEach(finalMenu, function (menu) {
          if(!isArtistCollection && menu.headerKey == 'category'){
            return;
          }
          let htmlDetails = self.getSideMenu(menu.headerKey);

          headerCount++;
          let menuCountUnderHeader = 0;

          let parentStart = htmlDetails.parentStart;
          parentStart = self.stringReplace(
            parentStart,
            "@header_key",
            menu.headerKey
          );
          parentStart = self.stringReplace(
            parentStart,
            "@header_name",
            menu.headerName
          );
          parentStart = self.stringReplace(
            parentStart,
            "@header_count",
            parseInt(headerCount)
          );
          parentStart = self.stringReplace(
            parentStart,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          parentStart = self.stringReplace(
            parentStart,
            "@menu_count",
            parseInt(menuCount)
          );

          let parentEnd = htmlDetails.parentEnd;
          parentEnd = self.stringReplace(
            parentEnd,
            "@header_key",
            menu.headerKey
          );
          parentEnd = self.stringReplace(
            parentEnd,
            "@header_name",
            menu.headerName
          );
          parentEnd = self.stringReplace(
            parentEnd,
            "@header_count",
            parseInt(headerCount)
          );
          parentEnd = self.stringReplace(
            parentEnd,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          parentEnd = self.stringReplace(
            parentEnd,
            "@menu_count",
            parseInt(menuCount)
          );

          let subMenuStart = htmlDetails.subMenuStart;
          subMenuStart = self.stringReplace(
            subMenuStart,
            "@header_key",
            menu.headerKey
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            "@header_name",
            menu.headerName
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            "@header_count",
            parseInt(headerCount)
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            "@menu_count",
            parseInt(menuCount)
          );

          console.log('menu:',menu.headerKey,' sub count:', menu.subMenus.length);
          let pStyle = '';
          let subStyle = '';
          if (document.querySelector('[data-artist]') && menu.headerKey == 'category') {
            pStyle += `class="filtz-open"`;
            subStyle += `class="filtz-open"`;
          } else if (urlCollection == 'accessories' && menu.headerKey == 'accessories_type') {
            pStyle += `class="filtz-open"`;
            subStyle += `class="filtz-open"`;
          } else if (menu.subMenus.length <= 5) {
            pStyle += `class="filtz-open"`;
            subStyle += `class="filtz-open"`;
          } else {
            subStyle += `style="display: none;"`;
          }


          parentStart = self.stringReplace(
            parentStart,
            "@drop_down_style",
            pStyle
          );

          subMenuStart = self.stringReplace(
            subMenuStart,
            "@drop_down_style",
            subStyle
          );

          let subMenuEnd = htmlDetails.subMenuEnd;
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            "@header_key",
            menu.headerKey
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            "@header_name",
            menu.headerName
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            "@header_count",
            parseInt(headerCount)
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            "@menu_count",
            parseInt(menuCount)
          );

          //@view_more
          if(menu.subMenus.length > 15){
            let viewMore = `<span class="view-more">View More</span>`;
            subMenuEnd = self.stringReplace(
              subMenuEnd,
              "@view_more",
              viewMore
            );
          }else{
            subMenuEnd = self.stringReplace(
              subMenuEnd,
              "@view_more",
              ''
            );
          }

          let subHtmls = "";
          let subMenuCount = 1;
          __.forEach(menu.subMenus, function (value, key) {
            menuCount++;
            menuCountUnderHeader++;

            let subMenuHtml = htmlDetails.subMenu;
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              "@header_key",
              menu.headerKey
            );
            //@hide_view_more
            if(subMenuCount > 15){
              subMenuHtml = self.stringReplace(
                subMenuHtml,
                "@hide_view_more",
                'hide-view-more'
              );
            }else{
              subMenuHtml = self.stringReplace(
                subMenuHtml,
                "@hide_view_more",
                ''
              );
            }

            subMenuHtml = self.stringReplace(
              subMenuHtml,
              "@header_name",
              menu.headerName
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              "@menu_key",
              value.subMenuKey
            );

            let filterValue = value.subMenuName;
            if (menu.decodedKey == 'color'){
							subMenuHtml = self.stringReplace(
								subMenuHtml,
								'@menu_name',
								filterValue.toLowerCase()
              );

							subMenuHtml = self.stringReplace(
								subMenuHtml,
                '@color_image_url',
                "https://cdn.shopify.com/s/files/1/0507/1526/3151/collections/"+filterValue.charAt(0).toUpperCase() + filterValue.slice(1)+"_180x.jpg"

							);
						}else if (menu.decodedKey == 'pattern'){
              subMenuHtml = self.stringReplace(
								subMenuHtml,
								'@menu_name',
								filterValue.toLowerCase()
              );
              if(filterValue.indexOf(' ') >= 0){
                filterValue = filterValue.replace(' ','_');
              }

							subMenuHtml = self.stringReplace(
								subMenuHtml,
                '@pattern_image_url',
                "https://cdn.shopify.com/s/files/1/0507/1526/3151/files/"+filterValue.toLowerCase() + ".png"

							);
            } else if (menu.decodedKey == 'size'){
              subMenuHtml = self.stringReplace(
								subMenuHtml,
								'@menu_name',
								filterValue.toUpperCase()
							);
            }
					else {
							subMenuHtml = self.stringReplace(
								subMenuHtml,
								'@menu_name',
								filterValue.charAt(0).toUpperCase() + filterValue.slice(1)
							);
					}

            subMenuHtml = self.stringReplace(
              subMenuHtml,
              "@header_count",
              parseInt(headerCount)
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              "@menu_count_under_header",
              parseInt(menuCountUnderHeader)
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              "@menu_count",
              parseInt(menuCount)
            );
            if (self.showCount) {
              subMenuHtml = self.stringReplace(
                subMenuHtml,
                "@count_placing",
                self.showCount
              );
            } else {
              subMenuHtml = self.stringReplace(
                subMenuHtml,
                "@count_placing",
                ""
              );
            }

            let tempHtml = $(subMenuHtml);
            if (!tempHtml.hasClass(filterClass)) {
              tempHtml.addClass(filterClass);
            }
            if (!tempHtml.hasClass(value.referenceClass)) {
              tempHtml.addClass(value.referenceClass);
            }
            subHtmls += self.htmlToString(tempHtml);
            subMenuCount++;
          });

          let htmlString =
            parentStart + subMenuStart + subHtmls + subMenuEnd + parentEnd;
          let template = Handlebars.compile(htmlString);
          if(isArtistCollection && menu.headerKey == 'category'){
            $('#filter-category-section').html(template);
          }else{
            $(self.menuLoadingEle).append(template);
          }
        });

        PF.addEntry("filter-bar-end", "Filter-bar created at ");
        PF.measure("filter-bar-start", "filter-bar-end", "FilterBarGeneration");
      })
      .then(function () {
        self.bindEvents();
      })
      .then(function () {
        afterFilterBarCreation();
      })
      .then(function () {
        PF.logInfo("Going to set count for the filter-bar.");
        self.setCount();
      })
      .then(function () {
        PF.logInfo("Going to check filters from URL.");
        self.checkUrlFilters();
      })
      .then(function () {
        PF.addEntry("process-end", "Ending process.");
        PF.measure("process-end", "process-end", "WholeProcess");
      });
  };
})(jQuery, window, document);
